<div #canvasContent>
  <button style="background-color: grey; color: white;" nz-button (click)="showModal()" nz-popover nzPopoverTitle="State Details"
  [nzPopoverContent]="tasksTimelineTemplate" nzTooltipPlacement="bottomRight">
    {{data.name}}   <span nz-icon nzType="bank" nzTheme="outline"></span>
  </button>
</div>
<ng-template #tasksTimelineTemplate>
  <nz-timeline class="p-20">
    <nz-timeline-item [nzDot]="timeWaitTemplate">
      State Details
      <small class="d-b">
        State Name: {{data.name}} 
      </small>
    </nz-timeline-item>
  </nz-timeline>
  <div class="footer-actions-bar">
    <div>
      <!-- Left -->
      <button nz-button [nzType]="'primary'" (click)="showModal()">Edit</button>
    </div>
    <div class="p-l-r-5"></div>
    <div>
      <!-- Right -->
      <button nz-button [nzType]="'primary'" (click)="deleteStep(data.id)">Delete</button>
    </div>
  </div>
</ng-template>

<nz-modal [(nzVisible)]="isVisible" nzTitle="{{data.name}}" (nzOnCancel)="handleCancel(data)" (nzOnOk)="handleOk(data)"
  [nzOkLoading]="isOkLoading">
  <ng-container *nzModalContent>
    <form nz-form>
      <div class="form-secondary-fields">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">State Name</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="State Name" [(ngModel)]="stepName" name="input-basic" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Description</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <textarea nz-input placeholder="Describe in brief ..." [(ngModel)]="statusDescription" name="statusDescription" nzAutosize></textarea>
          </nz-form-control>
        </nz-form-item>
        <!-- <nz-form-item>
          <nz-form-label [nzSpan]="24">Category</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
              <label nz-radio nzValue="A">Class XS</label>
              <label nz-radio nzValue="B">Class A</label>
              <label nz-radio nzValue="C">Class D</label>
              <label nz-radio nzValue="D">Class XE</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item> -->
      </div>
    </form>
    <!-- Rename State :
    <input nz-input [(ngModel)]="stepName"/>
    Add Properties :
    <input nz-input/> -->
  </ng-container>
</nz-modal>